const getters = {
  getExternalUsers(state, getters, rootState, rootGetters) {
    return rootGetters['project/getExternalUsers'];
  },

  getMembers(state, getters, rootState, rootGetters) {
    return rootGetters['workspace/getMembers'];
  },

  getParticipants(state, getters) {
    return [...getters.getExternalUsers, ...getters.getMembers];
  },

  getParticipant(state, getters) {
    return id => getters.getParticipants.find(user => user.id === id);
  },

  amIParticipant(state, getters, rootState, rootGetters) {
    const userId = rootGetters['user/account/getId'];
    if (!userId) {
      return false;
    }
    return getters.getParticipants.some(user => user.id === userId);
  },
};

const actions = {};

const mutations = {};

const modules = {};

const module = {
  namespaced: true,
  getters,
  mutations,
  actions,
  modules,
};

export default module;
